module.exports = __webpack_public_path__ + "static/img/withdraw2_3.62c5a765.png";